/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import apiData from './apiData'
import entities from './entities'
import auth from './auth'
import alerts from './alerts'
import localization from './localization'
import user from './user'
import modals from './modals'
import subscriptions from './subscriptions'
import formUtil from './form'
import pageScroller from './pageScroller'
import contacts from './contacts'

export const makeRootReducer = asyncReducers => {
  return combineReducers({
    entities,
    apiData,
    auth,
    alerts,
    localization,
    form,
    user,
    modals,
    subscriptions,
    formUtil,
    pageScroller,
    contacts,
    ...asyncReducers,
  })
}
